import { Injectable } from '@angular/core';

import { FormGroup, AbstractControl, FormControl, FormArray } from '@angular/forms';
import * as _ from 'lodash';

@Injectable()
export class FormFieldValidationService {

    constructor() { }

    validateAllFormGroupFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            this.validateAllFormControlFields(control);
        });
    }

    private validateAllFormControlFields(control: AbstractControl) {
        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
            this.validateAllFormGroupFields(control);
        } else if (control instanceof FormArray) {
            _.each(control.controls, (childControl) => {
                this.validateAllFormControlFields(childControl);
            });
        }
    }
}
